import React, {useContext, useEffect, useState, useRef} from 'react';
import Typography from '@material-ui/core/Typography';
import {makeStyles} from '@material-ui/core/styles';
import AppContext from '../../Services/AppContext';
import PersistantData from '../../Services/PersistantData';
import Button from '@material-ui/core/Button';
import {useCommonStyles} from '../../Styles';
import {
    defDateFormat,
    empty,
    req_cust,
    req_stock,
    req_salesman,
    req_delete_file,
    req_report_itemdistributionanalysis,
    req_report_itemdistributionanalysisreport,
    req_report_itemdistributionanalysis_alt,
	req_report_itemdistributionanalysisreport_alt,
    req_cust_category,
    req_module_setting
} from '../../Helper/Constants';
import _ from 'lodash';
import JString from '@easytech-international-sdn-bhd/jstring';
import API_Service, {axiosDefaultConfig, axiosURIencode} from '../../Services/API_Service';
import {useSnackbar} from 'notistack';
import KeyboardArrowDownRoundedIcon from '@material-ui/icons/KeyboardArrowDownRounded';
import DateRangePickerModal from '../../Components/DateRangePickerModal';
import moment from 'moment';
import VirtualListCB from '../../Components/VirtualListCB';
import format from 'date-fns/format';
import {de, getSetting} from '../../Helper/Helper';
import useColumnPreference from '../../Services/useColumnPreference';
import { Paper, Table, TableBody, TableCell, TableContainer, TableRow, TableHead, CircularProgress, TextField, InputAdornment, Tabs, Tab, Select, MenuItem, FormControl, Switch, FormControlLabel, Grid } from '@material-ui/core';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import InsertInvitationIcon from '@material-ui/icons/InsertInvitation';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import MUIDataTable from 'mui-datatables';
import {IconButton, Tooltip} from '@material-ui/core';
import {Assessment as AssessmentIcon} from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
    viewInRow: {
		display: 'flex',
		flexWrap: 'wrap',
		alignItems: 'left',
		marginTop: theme.spacing(1),
		rowGap: 10
	},
	container: {
        maxHeight: '78vh',
        maxWidth: '92vw',
    },
    boldText: {
        fontWeight: 'bold',
    },
    tableHeadRow: {
        backgroundColor: '#424242',
		fontSize: 10,
		padding: 0,
		margin: 0
    },
	tableCellAutoWidth: {
		whiteSpace: "nowrap", 
		overflow: "hidden",
		fontSize: 12,
		padding: 0,
		margin: 0
	},
	table : {
		fontSize: 12,
		borderCollapse: 'separate',
    	borderSpacing: '4px 0px'
	},
	customDatePicker: {
		"& .MuiOutlinedInput-root" : {
			height: "100%",
		},
		"& .MuiOutlinedInput-root .MuiOutlinedInput-input": {
			padding: "5px 15px",
			fontSize: 12,
			textAlign: "center",
		},
		width: 300,
		marginRight: 10,
		fontSize: 12,
	},
	// 自定义滚动条样式
	customScrollContainer: {
		// 针对Webkit浏览器 (Chrome, Safari, Edge)
		'&::-webkit-scrollbar': {
			height: 12,
			width: 12,
		},
		'&::-webkit-scrollbar-track': {
			backgroundColor: '#2d2d2d',
			borderRadius: 6,
		},
		'&::-webkit-scrollbar-thumb': {
			backgroundColor: '#555555',
			borderRadius: 6,
			border: '2px solid #2d2d2d',
			'&:hover': {
				backgroundColor: '#777777',
			},
		},
		'&::-webkit-scrollbar-corner': {
			backgroundColor: '#2d2d2d',
		},
		// 针对Firefox
		scrollbarWidth: 'thin',
		scrollbarColor: '#555555 #2d2d2d',
	},
}));

const tableHead = [
	{
		name: "product_code",
		label: "Product Code",
		options: {
			display: true
		}
	},{
		name: "product_name",
		label: "Item",
		options: {
			display: true
		}
	},
	{
		name: "category_name",
		label: "Item Category",
		options: {
			display: true
		}
	},
	{
		name: "brand_name",
		label: "Item Brand",
		options: {
			display: true
		}
	},
	{
		name: "total_visited_outlet",
		label: "Total Outlet Visited",
		options: {
			display: true,
		}
	},
	{
		name: "total_customer",
		label: "Total Outlet Assigned",
		options: {
			display: true,
		}
	}
];

// 创建冻结列配置的通用函数
const createStickyColumnConfig = (columnName, label, leftPosition, width = '120px') => ({
	name: columnName,
	label: label,
	options: {
		display: true,
		setCellProps: () => ({
			style: {
				position: 'sticky',
				left: leftPosition,
				zIndex: 1000,
				backgroundColor: '#424242',
				color: '#e0e0e0',
				// borderRight: leftPosition === 440 ? '2px solid #666' : '1px solid #555', // 最后一列使用粗边框
				minWidth: width,
				maxWidth: width,
				width: width
			}
		}),
		setCellHeaderProps: () => ({
			style: {
				position: 'sticky',
				left: leftPosition,
				zIndex: 1100,
				backgroundColor: '#424242',
				color: 'white',
				// borderRight: leftPosition === 440 ? '2px solid #666' : '1px solid #555',
				minWidth: width,
				maxWidth: width,
				width: width
			}
		})
	}
});

// 创建基础冻结列数组
const createBaseStickyColumns = () => [
	createStickyColumnConfig("product_code", "Product Code", 0, '120px'),
	createStickyColumnConfig("product_name", "Item", 120, '180px'),
	createStickyColumnConfig("category_name", "Item Category", 300, '140px'),
	createStickyColumnConfig("brand_name", "Item Brand", 440, '140px')
];

export default function RItemDistAnalysis() {
    const classes = useStyles();
    const commonStyle = useCommonStyles();
    const [gState, setGState] = useContext(AppContext);
	var {translation: language, client} = gState;
	
	// 动态宽度和高度管理
	const containerRef = useRef(null);
	const [containerWidth, setContainerWidth] = useState('calc(100vw - 320px)');
	const [containerHeight, setContainerHeight] = useState('calc(100vh - 300px)');
	
	// 检测导航栏状态并调整宽度和高度
	useEffect(() => {
		const updateDimensions = () => {
			// 检测drawer是否打开 - 计算宽度
			const drawer = document.querySelector('.MuiDrawer-root');
			if (drawer) {
				const drawerRect = drawer.getBoundingClientRect();
				const isDrawerOpen = drawerRect.width > 100; // 275px为完全打开，60-70px为关闭状态
				
				if (isDrawerOpen) {
					setContainerWidth('calc(100vw - 320px)'); // 导航栏打开
				} else {
					setContainerWidth('calc(100vw - 120px)'); // 导航栏关闭，留少量边距
				}
			}
			
			// 计算高度 - 动态计算页面各部分占用的高度
			let totalOffset = 0;
			
			// 顶部应用栏
			const appBar = document.querySelector('.MuiAppBar-root');
			if (appBar) {
				totalOffset += appBar.offsetHeight;
			}
			
			// 标签页容器
			const tabsContainer = document.querySelector('.MuiTabs-root');
			if (tabsContainer) {
				totalOffset += tabsContainer.offsetHeight;
			}
			
			// 筛选器行
			const filterRow = document.querySelector('[class*="viewInRow"]');
			if (filterRow) {
				totalOffset += filterRow.offsetHeight + 20; // 减少边距
			}
			
			// 表格标题和工具栏的预估高度（更精确）
			const tableHeaderOffset = 60;
			totalOffset += tableHeaderOffset;
			
			// 底部分页器和边距（最小化）
			const bottomOffset = 20;
			totalOffset += bottomOffset;
			
			// 计算最终高度，确保最小高度
			const minHeight = 400;
			const calculatedHeight = Math.max(window.innerHeight - totalOffset, minHeight);
			setContainerHeight(`${calculatedHeight}px`);
		};
		
		// 初始检测（延迟确保DOM完全渲染）
		setTimeout(updateDimensions, 100);
		
		// 监听窗口大小变化
		window.addEventListener('resize', updateDimensions);
		
		// 监听DOM变化（导航栏开关、内容变化）
		const observer = new MutationObserver(() => {
			setTimeout(updateDimensions, 300); // 延迟等待动画完成
		});
		
		const targetNode = document.body;
		observer.observe(targetNode, {
			attributes: true,
			subtree: true,
			attributeFilter: ['class']
		});
		
		return () => {
			window.removeEventListener('resize', updateDimensions);
			observer.disconnect();
		};
	}, []);
    const singleton = PersistantData.getInstance();
	if (typeof (language) === 'undefined') {
		language = singleton.getlang()
	}
    const {enqueueSnackbar, closeSnackbar} = useSnackbar();
    const snack = (msg, type = 'success') => {
		enqueueSnackbar(msg, {
			variant: type,
			preventDuplicate: true,
			autoHideDuration: type === 'success' ? 2000 : 3000
		});
	}

    const [splist, setSPlist] = useState([]);
	const [outletList, setOutletList] = useState([]);
    const [outletCategoryList, setOutletCategoryList] = useState([]);
    const [stateList, setStateList] = useState([]);
    const [itemList, setItemList] = useState([]);

    const [spView, setSpView] = useState(false);
	const [spSelectedValue, setSpSelectedValue] = useState(empty);
	const [spSelectedName, setSpSelectedName] = useState(empty);

	const [outletView, setOutletView] = useState(false);
	const [outletSelectedName, setOutletSelectedName] = useState(empty);
	const [outletSelectedValue, setOutletSelectedValue] = useState(empty);

    const [categoryListView, setCategoryListView] = useState(false);
    const [categorySelectedName, setCategorySelectedName] = useState(empty);
    const [categorySelectedValue, setCategorySelectedValue] = useState(empty);

    const [productListView, setProductListView] = useState(false);
    const [selectedProductName, setSelectedProductName] = useState(empty);
    const [selectedProductValue, setSelectedProductValue] = useState(empty);

    const [stateListView, setStateListView] = useState(false);
    const [selectedStateValue, setSelectedStateValue] = useState(empty);
	const [selectedStateName, setSelectedStateName] = useState(empty);

    const [outletVisitDateRange, setOutletVisitDateRange] = useState({});
    const [openOutletVisitDateDoc, setOpenOutletVisitDateDoc] = useState(false);

    const [loading, setLoading] = useState(false);
    const [tableHeader, setTableHeader] = useState([]);
	const [tableHeader2, setTableHeader2] = useState([]);
	const [tableHeader3, setTableHeader3] = useState([]);
	const [reportData, setReportData] = useState([]);
	const [reportData2, setReportData2] = useState([]);
	const [reportData3, setReportData3] = useState([]);
	const [selectedTab, setSelectedTab] = useState(0);
	
	// Toggle states for each table
	const [toggleState1, setToggleState1] = useState(false);
	const [toggleState2, setToggleState2] = useState(false);
	const [toggleState3, setToggleState3] = useState(false);
	
	// New state variables for alternative API tables
	const [tableHeaderAlt, setTableHeaderAlt] = useState([]);
	const [tableHeaderAlt2, setTableHeaderAlt2] = useState([]);
	const [tableHeaderAlt3, setTableHeaderAlt3] = useState([]);
	const [reportDataAlt, setReportDataAlt] = useState([]);
	const [reportDataAlt2, setReportDataAlt2] = useState([]);
	const [reportDataAlt3, setReportDataAlt3] = useState([]);

	const { columns: preferredColumns1, onColumnViewChange: onPrefColumnViewChange1 } = useColumnPreference('RItemDistAnalysis_1', tableHeader, client);
	const { columns: preferredColumns2, onColumnViewChange: onPrefColumnViewChange2 } = useColumnPreference('RItemDistAnalysis_2', tableHeader2, client);
	const { columns: preferredColumns3, onColumnViewChange: onPrefColumnViewChange3 } = useColumnPreference('RItemDistAnalysis_3', tableHeader3, client);
	const { columns: preferredColumnsAlt1, onColumnViewChange: onPrefColumnViewChangeAlt1 } = useColumnPreference('RItemDistAnalysis_4', tableHeaderAlt, client);
	const { columns: preferredColumnsAlt2, onColumnViewChange: onPrefColumnViewChangeAlt2 } = useColumnPreference('RItemDistAnalysis_5', tableHeaderAlt2, client);
	const { columns: preferredColumnsAlt3, onColumnViewChange: onPrefColumnViewChangeAlt3 } = useColumnPreference('RItemDistAnalysis_6', tableHeaderAlt3, client);

	const handleTabChange = (event, newValue) => {
		setSelectedTab(newValue);
	};
	
	// Toggle handlers for each table
	const handleToggleChange1 = () => {
		setToggleState1(!toggleState1);
	};
	
	const handleToggleChange2 = () => {
		setToggleState2(!toggleState2);
	};
	
	const handleToggleChange3 = () => {
		setToggleState3(!toggleState3);
	};

    const getOutletVisitDate = () => {
		return !_.isEmpty(outletVisitDateRange) ? moment(outletVisitDateRange.startDate).format('DD MMMM YYYY') + " / " + moment(outletVisitDateRange.endDate).format('DD MMMM YYYY') : moment(new Date()).format('DD MMMM YYYY') + " / " + moment(new Date()).format('DD MMMM YYYY');
	}

    useEffect(() => {
		if (JString(gState.client).isValid()) {
            loadModule(gState.client);
            // getSalesmanList(gState.client);
			getOutletList(gState.client);
            getOutletCategory(gState.client);
            loadStocksList(gState.client);
		}
	}, [gState.client]);

    const loadModule = (_client = client) => {
        API_Service.get(req_module_setting, axiosDefaultConfig(_client)).then(({data}) => {
			const {result, extraData} = data;
			if (result) {
				const country = getSetting(extraData, 'country');
				let country_arr = [JSON.parse(JSON.stringify(country))];
				var status = country_arr[0].states;
				var _status = [];
				for (let i = 0; i < status?.length; i++) {
					const {name} = status[i];
					_status.push({name: name, secondary: name, value: name, status: 1});
				}
				setStateList(_status);
			} else {
				snack(language.not_found_salesperson, 'warning');
			}
		});
    }

    const getSalesmanList = (_client = client) => {
		API_Service.get(req_salesman, axiosDefaultConfig(_client)).then(({data}) => {
			const {result, extraData} = data;
			if (result) {
				var _data = [];
				for (let idx = 0; idx < extraData.length; idx++) {
					const {name, login_id, login} = extraData[idx];
					_data.push({name: name, secondary: login, value: login_id});
				}
				setSPlist(splist => (_data));
			} else {
				snack(gState.translation.not_found_salesperson, 'warning');
			}
		});
	}

	const getOutletList = (_client = client) => {
		API_Service.get(req_cust, axiosDefaultConfig(_client)).then(({data}) => {
			const {result, extraData} = data;
			var {customer, inactive_customer} = extraData;
			if (parseInt(result) === 1) {
				var arr = [];
				for (let i = 0; i < customer.length; i++) {
					const {cust_id, cust_code, cust_company_name} = customer[i];
					arr.push({
						name: cust_company_name,
						secondary: cust_code,
						value: cust_id,
                        status: 1
					});
				}
                for (let i = 0; i < inactive_customer.length; i++) {
					const {cust_id, cust_code, cust_company_name} = inactive_customer[i];
					arr.push({
						name: cust_company_name,
						secondary: cust_code,
						value: cust_id,
						status: 0
                    });
                }
				setOutletList(arr);
			}
		});
	}

    const getOutletCategory = (_client = client) => {
        API_Service.get(req_cust_category, axiosDefaultConfig(_client)).then(({data}) => {
			if (data) {
				var {result, extraData } = data;

				result = JString(result).toNumber();
				if (result === 1) {
					var _data = [];
					for (let i = 0; i < extraData.length; i++) {
						const {cust_category_name, cust_category_code, cust_category_id, cust_category_status} = extraData[i];
						if (parseInt(cust_category_status) === 1) {
							_data.push({
                                name: cust_category_name,
                                secondary: cust_category_code,
                                value: cust_category_id,
                                status: 1
                            });
						} else {
							_data.push({
                                name: cust_category_name,
                                secondary: cust_category_code,
                                value: cust_category_id,
                                status: 0
                            });
						}
					}
					setOutletCategoryList(()=>(_data));
				}
			}
		}).catch(err => de(err.message, 'customer category list'));
    }

    const loadStocksList = (_client = client) => {
		var req = `${req_stock}-1`;
		API_Service.get(req, axiosDefaultConfig(_client)).then(({data}) => {
			const {result, extraData} = data;
			const {stock: stockApi} = extraData;
			if (result) {
				var _data = [];
				for (let idx = 0; idx < stockApi.length; idx++) {
					const {product_name, product_code, product_status} = stockApi[idx];
					_data.push({name: product_name, secondary: product_code, value: product_code, status: parseInt(product_status)});
				}
				setItemList(itemList => (_data));
			}
		});
	}

    const OutletVisitSPViewClose = (newValue) => {
		setSpView(false);
		if (newValue) {
			var spvalue = '';
			for (let i = 0; i < newValue.length; i++) {
				if (i == newValue.length - 1) {
					spvalue += newValue[i].value;
				} else {
					spvalue += newValue[i].value + ",";
				}
			}
			setSpSelectedValue(spvalue);

			var spname = '';
			for (let i = 0; i < newValue.length; i++) {
				if (i == newValue.length - 1) {
					spname += newValue[i].name;
				} else {
					spname += newValue[i].name + ",";
				}
			}
			setSpSelectedName(spname);
		}
	}

	const OutletVisitOutletViewClose = (newValue) => {
		setOutletView(false);
		if (newValue) {
			var custvalue = '';
			for (let i = 0; i < newValue.length; i++) {
				if (i == newValue.length - 1) {
					custvalue += newValue[i].value;
				} else {
					custvalue += newValue[i].value + ",";
				}
			}
			setOutletSelectedValue(custvalue);

			var custname = '';
			for (let i = 0; i < newValue.length; i++) {
				if (i == newValue.length - 1) {
					custname += newValue[i].name;
				} else {
					custname += newValue[i].name + ",";
				}
			}
			setOutletSelectedName(custname);
		}
	}

    const CategoryViewClose = (newValue) => {
        setCategoryListView(false);
        if (newValue) {
			var value = '';
			for (let i = 0; i < newValue.length; i++) {
				if (i == newValue.length - 1) {
					value += newValue[i].value;
				} else {
					value += newValue[i].value + ",";
				}
			}
			setCategorySelectedValue(value);

			var name = '';
			for (let i = 0; i < newValue.length; i++) {
				if (i == newValue.length - 1) {
					name += newValue[i].name;
				} else {
					name += newValue[i].name + ",";
				}
			}
			setCategorySelectedName(name);
		}
    }

    const StateViewClose = (newValue) => {
		setStateListView(false);
		if (newValue) {
			var statevalue = '';
			for (let i = 0; i < newValue.length; i++) {
				if (i == newValue.length - 1) {
					statevalue += newValue[i].value;
				} else {
					statevalue += newValue[i].value + ",";
				}
			}
			setSelectedStateValue(statevalue);

			var statename = '';
			for (let i = 0; i < newValue.length; i++) {
				if (i == newValue.length - 1) {
					statename += newValue[i].name;
				} else {
					statename += newValue[i].name + ",";
				}
			}
			setSelectedStateName(statename);
		}
	}

    const ProductViewClose = (newValue) => {
		setProductListView(false);
		if (newValue) {
			var itemsvalue = '';
			for (let i = 0; i < newValue.length; i++) {
				if (i == newValue.length - 1) {
					itemsvalue += newValue[i].value;
				} else {
					itemsvalue += newValue[i].value + ",";
				}
			}
			setSelectedProductValue(itemsvalue);

			var itemsname = '';
			for (let i = 0; i < newValue.length; i++) {
				if (i == newValue.length - 1) {
					itemsname += newValue[i].name;
				} else {
					itemsname += newValue[i].name + ",";
				}
			}
			setSelectedProductName(itemsname);
		}
	}

    const getReportData = (_client = client) => {
        setLoading(true);
		var st_date = '';
		var st_date_to = '';
		if (!_.isEmpty(outletVisitDateRange)) {
			st_date = format(outletVisitDateRange.startDate, defDateFormat);
			st_date_to = format(outletVisitDateRange.endDate, defDateFormat);
		}
        var parameters = {
            date_from: st_date,
            date_to: st_date_to,
            salespersonId: spSelectedValue,
            cust_id: outletSelectedValue,
            cust_category_id: categorySelectedValue,
            cust_state: selectedStateValue,
            product_code: selectedProductValue
        };
        const param = axiosURIencode(parameters);
        const table_head = [
            ...createBaseStickyColumns(),
			{
				name: "total_visited_outlet",
				label: "Total Outlet Visited",
				options: {
					display: true,
				}
			},
            {
                name: "total_customer",
                label: "Total Outlet Assigned",
                options: {
                    display: true,
                }
            }
        ];
		const table_head2 = [
            ...createBaseStickyColumns(),
			{
				name: "total_visited_outlet",
				label: "Total Outlet Visited",
				options: {
					display: true,
				}
			},
            {
                name: "total_customer",
                label: "Total Outlet Assigned",
                options: {
                    display: true,
                }
            }
        ];
		const table_head3 = [
            ...createBaseStickyColumns(),
			{
				name: "total_visited_outlet",
				label: "Total Outlet Visited",
				options: {
					display: true,
				}
			},
            {
                name: "total_customer",
                label: "Total Outlet Assigned",
                options: {
                    display: true,
                }
            }
        ];

		API_Service.get(`${req_report_itemdistributionanalysis}?${param}`, axiosDefaultConfig(_client)).then(({data}) => {
			const {result, extraData} = data;
			if (result) {
                const {data, header} = extraData;
                setReportData(data);
                const reversedHeader = [...header].reverse();
                for (let x = 0; x < reversedHeader.length; x++) {
                    table_head.splice(4, 0, {
                        name: reversedHeader[x],
                        label: reversedHeader[x].includes('%') ? '%' : reversedHeader[x],
                        options: {
                            display: true
                        }
                    });
                }

                table_head.push({
                    name: "Average",
                    label: "Average",
                    options: {
                        display: true
                    }
                });
                table_head.push({
                    name: "Dist %",
                    label: "Dist %",
                    options: {
                        display: true
                    }
                });
                setTableHeader(table_head);

				const {data2, header2} = extraData;
				setReportData2(data2);
				const reversedHeader2 = [...header2].reverse();
				for (let x = 0; x < reversedHeader2.length; x++) {
					table_head2.splice(4, 0, {
						name: reversedHeader2[x],
						label: reversedHeader2[x].includes('%') ? '%' : reversedHeader2[x],
						options: {
							display: true
						}
					});
				}
				table_head2.push({
					name: "Average",
					label: "Average",
					options: {
						display: true
					}
				});
				table_head2.push({
					name: "Dist %",
					label: "Dist %",
					options: {
						display: true
					}
				});
				setTableHeader2(table_head2);

				const {data3, header3} = extraData;
				setReportData3(data3);
				const reversedHeader3 = [...header3].reverse();
				for (let x = 0; x < reversedHeader3.length; x++) {
					table_head3.splice(4, 0, {
						name: reversedHeader3[x],
						label: reversedHeader3[x].includes('%') ? '%' : reversedHeader3[x],
						options: {
							display: true
						}
					});
				}
				table_head3.push({
					name: "Average",
					label: "Average",
					options: {
						display: true
					}
				});
				table_head3.push({
					name: "Dist %",
					label: "Dist %",
					options: {
						display: true
					}
				});
				setTableHeader3(table_head3);

			} else {
                setReportData([]);
				setReportData2([]);
				setReportData3([]);
                setTableHeader([]);
				setTableHeader2([]);
				setTableHeader3([]);
                snack(language.no_data, 'warning');
            }
            setLoading(false);
		});
	}

    const getReportDataAlt = (_client = client) => {
        setLoading(true);
		var st_date = '';
		var st_date_to = '';
		if (!_.isEmpty(outletVisitDateRange)) {
			st_date = format(outletVisitDateRange.startDate, defDateFormat);
			st_date_to = format(outletVisitDateRange.endDate, defDateFormat);
		}
        var parameters = {
            date_from: st_date,
            date_to: st_date_to,
            salespersonId: spSelectedValue,
            cust_id: outletSelectedValue,
            cust_category_id: categorySelectedValue,
            cust_state: selectedStateValue,
            product_code: selectedProductValue
        };
        const param = axiosURIencode(parameters);
        const table_head_alt = [
            ...createBaseStickyColumns(),
			{
				name: "total_visited_outlet",
				label: "Total Outlet Visited",
				options: {
					display: true,
				}
			},
            {
                name: "total_customer",
                label: "Total Outlet Assigned",
                options: {
                    display: true,
                }
            }
        ];
		const table_head_alt2 = [
            ...createBaseStickyColumns(),
			{
				name: "total_visited_outlet",
				label: "Total Outlet Visited",
				options: {
					display: true,
				}
			},
            {
                name: "total_customer",
                label: "Total Outlet Assigned",
                options: {
                    display: true,
                }
            }
        ];
		const table_head_alt3 = [
            ...createBaseStickyColumns(),
			{
				name: "total_visited_outlet",
				label: "Total Outlet Visited",
				options: {
					display: true,
				}
			},
            {
                name: "total_customer",
                label: "Total Outlet Assigned",
                options: {
                    display: true,
                }
            }
        ];

		API_Service.get(`${req_report_itemdistributionanalysis_alt}?${param}`, axiosDefaultConfig(_client)).then(({data}) => {
			const {result, extraData} = data;
			if (result) {
                const {data, header} = extraData;
                setReportDataAlt(data);
                const reversedHeader = [...header].reverse();
                for (let x = 0; x < reversedHeader.length; x++) {
                    table_head_alt.splice(4, 0, {
                        name: reversedHeader[x],
                        label: reversedHeader[x].includes('%') ? '%' : reversedHeader[x],
                        options: {
                            display: true
                        }
                    });
                }

                table_head_alt.push({
                    name: "Average",
                    label: "Average",
                    options: {
                        display: true
                    }
                });
                table_head_alt.push({
                    name: "Dist %",
                    label: "Dist %",
                    options: {
                        display: true
                    }
                });
                setTableHeaderAlt(table_head_alt);

				const {data2, header2} = extraData;
				setReportDataAlt2(data2);
				const reversedHeader2 = [...header2].reverse();
				for (let x = 0; x < reversedHeader2.length; x++) {
					table_head_alt2.splice(4, 0, {
						name: reversedHeader2[x],
						label: reversedHeader2[x].includes('%') ? '%' : reversedHeader2[x],
						options: {
							display: true
						}
					});
				}
				table_head_alt2.push({
					name: "Average",
					label: "Average",
					options: {
						display: true
					}
				});
				table_head_alt2.push({
					name: "Dist %",
					label: "Dist %",
					options: {
						display: true
					}
				});
				setTableHeaderAlt2(table_head_alt2);

				const {data3, header3} = extraData;
				setReportDataAlt3(data3);
				const reversedHeader3 = [...header3].reverse();
				for (let x = 0; x < reversedHeader3.length; x++) {
					table_head_alt3.splice(4, 0, {
						name: reversedHeader3[x],
						label: reversedHeader3[x].includes('%') ? '%' : reversedHeader3[x],
						options: {
							display: true
						}
					});
				}
				table_head_alt3.push({
					name: "Average",
					label: "Average",
					options: {
						display: true
					}
				});
				table_head_alt3.push({
					name: "Dist %",
					label: "Dist %",
					options: {
						display: true
					}
				});
				setTableHeaderAlt3(table_head_alt3);

			} else {
                setReportDataAlt([]);
				setReportDataAlt2([]);
				setReportDataAlt3([]);
                setTableHeaderAlt([]);
				setTableHeaderAlt2([]);
				setTableHeaderAlt3([]);
                snack(language.no_data, 'warning');
            }
            setLoading(false);
		});
	}

    const onGenerateReport = (_client = client) => {
        setLoading(true);
		var st_date = '';
		var st_date_to = '';
		if (!_.isEmpty(outletVisitDateRange)) {
			st_date = format(outletVisitDateRange.startDate, defDateFormat);
			st_date_to = format(outletVisitDateRange.endDate, defDateFormat);
		}
        var parameters = {
			type: selectedTab,
            date_from: st_date,
            date_to: st_date_to,
            salespersonId: spSelectedValue,
            cust_id: outletSelectedValue,
            cust_category_id: categorySelectedValue,
            cust_state: selectedStateValue,
            product_code: selectedProductValue
        };
        const param = axiosURIencode(parameters);

		API_Service.get(`${req_report_itemdistributionanalysisreport}?${param}`, axiosDefaultConfig(_client)).then(({data}) => {
			const {result, extraData} = data;
			if (result) {
                window.open(extraData.url, '_blank');
                const delay = setTimeout(() => {
                    API_Service.get(`${req_delete_file}?filename=${extraData.filename}`, axiosDefaultConfig(_client));
                    clearTimeout(delay);
                }, 5000);
            } else {
                snack(language.no_data, 'warning');
            }
			setLoading(false);
        });
	}

    const onGenerateReportAlt = (_client = client) => {
        setLoading(true);
        var st_date = '';
        var st_date_to = '';
        if (!_.isEmpty(outletVisitDateRange)) {
            st_date = format(outletVisitDateRange.startDate, defDateFormat);
            st_date_to = format(outletVisitDateRange.endDate, defDateFormat);
        }
        var parameters = {
			type: selectedTab,
            date_from: st_date,
            date_to: st_date_to,
            salespersonId: spSelectedValue,
            cust_id: outletSelectedValue,
            cust_category_id: categorySelectedValue,
            cust_state: selectedStateValue,
            product_code: selectedProductValue
        };
        const param = axiosURIencode(parameters);

        API_Service.get(`${req_report_itemdistributionanalysisreport_alt}?${param}`, axiosDefaultConfig(_client)).then(({data}) => {
            const {result, extraData} = data;
            if (result) {
                window.open(extraData.url, '_blank');
                const delay = setTimeout(() => {
                    API_Service.get(`${req_delete_file}?filename=${extraData.filename}`, axiosDefaultConfig(_client));
                    clearTimeout(delay);
                }, 5000);
            } else {
                snack(language.no_data, 'warning');
            }
            setLoading(false);
        });
    }

	return (
		<div style={{height: '100%'}}>
            <div className={classes.viewInRow}>
				{/* <Button
					style={{width: 300, marginRight: 10}}
					variant="outlined"
					onClick={() => setSpView(true)}
					endIcon={<KeyboardArrowDownRoundedIcon/>}>
					<Typography className={commonStyle.searchBtnFont}>
						{spSelectedName ? _.truncate(spSelectedName, {length: 20}) : language.salesperson}
					</Typography>
				</Button> */}
				<Button
					style={{width: 300, marginRight: 10}}
					variant="outlined"
					onClick={() => setOutletView(true)}
					endIcon={<KeyboardArrowDownRoundedIcon/>}>
					<Typography className={commonStyle.searchBtnFont}>
						{outletSelectedName ? _.truncate(outletSelectedName, {length: 20}) : language.customer}
					</Typography>
				</Button>
                <Button
					style={{width: 300, marginRight: 10}}
					variant="outlined"
					onClick={() => setCategoryListView(true)}
					endIcon={<KeyboardArrowDownRoundedIcon/>}>
					<Typography className={commonStyle.searchBtnFont}>
						{categorySelectedName ? _.truncate(categorySelectedName, {length: 20}) : language.category}
					</Typography>
				</Button>
                <Button
					style={{width: 300, marginRight: 10}}
					variant="outlined"
					onClick={() => setStateListView(true)}
					endIcon={<KeyboardArrowDownRoundedIcon/>}>
					<Typography className={commonStyle.searchBtnFont}>
						{selectedStateName ? _.truncate(selectedStateName, {length: 20}) : language.state}
					</Typography>
				</Button>
                {/* <Button
					style={{width: 300, marginRight: 10}}
					variant="outlined"
					onClick={() => setProductListView(true)}
					endIcon={<KeyboardArrowDownRoundedIcon/>}>
					<Typography className={commonStyle.searchBtnFont}>
						{selectedProductName ? _.truncate(selectedProductName, {length: 20}) : language.items}
					</Typography>
				</Button> */}
                <Button
					style={{width: 300, marginRight: 10}}
					variant="outlined"
					onClick={() => setOpenOutletVisitDateDoc(true)}>
					<Typography className={commonStyle.searchBtnFont}>
						{getOutletVisitDate()}
					</Typography>
				</Button>
				<Button
					style={{marginRight: 10}}
					size="small"
					color="primary"
					variant={'contained'}
					onClick={() => (getReportData(), getReportDataAlt())}
					disabled={loading ? true : false}>
					<Typography className={commonStyle.searchBtnFont}>{language.view}</Typography>
					{
						loading ? <CircularProgress size={20}/> : ''
					}
				</Button>
			</div>
			<div style={{height: 20}}/>
			<Tabs
				value={selectedTab}
				onChange={handleTabChange}
				indicatorColor="primary"
				textColor="primary"
				variant="standard"
			>
				<Tab label="Monthly" />
				<Tab label="Quarterly" />
				<Tab label="Half Year" />
			</Tabs>
			{
                selectedTab === 0 && toggleState1 == false && reportData.length > 0 && (
                    <div 
						ref={containerRef}
						className={classes.customScrollContainer}
						style={{
							width: '100%',
							maxWidth: containerWidth,
							minWidth: '600px',
							height: containerHeight,
							maxHeight: containerHeight,
							overflowX: 'auto',
							overflowY: 'auto'
						}}>
						<div style={{minWidth: 'max-content'}}>
							<MUIDataTable
								title={language.item_distribution_analysis + " (Based on Total Outlet Visited)"}
								data={reportData}
								columns={preferredColumns1}
								options={{
									search: false,
									print: false,
									filter: false,
									download: false,
									selectableRows: 'none',
									rowsPerPage: 100,
									rowsPerPageOptions: [100, 200, 300, 400],
									responsive: 'standard',
									pagination: true,
									tableBodyMaxHeight: `calc(${containerHeight} - 80px)`,
									onColumnViewChange: onPrefColumnViewChange1,
									setTableProps: () => ({size: 'small'}),
									customToolbar: () =>
										<Grid container alignItems="center" justifyContent="flex-end" spacing={2} style={{marginTop: -57, paddingRight: 60}}>
											<Grid item style={{marginTop: 4}}>
												<FormControlLabel
													control={
														<Switch
															checked={toggleState1}
															onClick={handleToggleChange1}
															color="primary"
														/>
													}
													label="Total Outlet Visited"
													labelPlacement="start"
												/>
											</Grid>

											<Grid item>
												<CheckinTableReportButton onGenerateReport={onGenerateReport} />
											</Grid>
										</Grid>
								}}
							/>
						</div>
					</div>
                )
            }
			{
                selectedTab === 1 && toggleState2 == false && reportData2.length > 0 && (
                    <div 
						className={classes.customScrollContainer}
						style={{
							width: '100%',
							maxWidth: containerWidth,
							minWidth: '600px',
							height: containerHeight,
							maxHeight: containerHeight,
							overflowX: 'auto',
							overflowY: 'auto'
						}}>
						<div style={{minWidth: 'max-content'}}>
							<MUIDataTable
								title={language.item_distribution_analysis + " (Based on Total Outlet Visited)"}
								data={reportData2}
								columns={preferredColumns2}
								options={{
									search: false,
									print: false,
									filter: false,
									download: false,
									selectableRows: 'none',
									rowsPerPage: 100,
									rowsPerPageOptions: [100, 200, 300, 400],
									responsive: 'standard',
									pagination: true,
									tableBodyMaxHeight: `calc(${containerHeight} - 80px)`,
									onColumnViewChange: onPrefColumnViewChange2,
									setTableProps: () => ({size: 'small'}),
									customToolbar: () =>
										<Grid container alignItems="center" justifyContent="flex-end" spacing={2} style={{marginTop: -57, paddingRight: 60}}>
											<Grid item style={{marginTop: 4}}>
												<FormControlLabel
													control={
														<Switch
															checked={toggleState2}
															onClick={handleToggleChange2}
															color="primary"
														/>
													}
													label="Total Outlet Visited"
													labelPlacement="start"
												/>
											</Grid>

											<Grid item>
												<CheckinTableReportButton onGenerateReport={onGenerateReport} />
											</Grid>
										</Grid>
								}}
							/>
						</div>
					</div>
                )
            }
			{
                selectedTab === 2 && toggleState3 == false && reportData3.length > 0 && (
                    <div 
						className={classes.customScrollContainer}
						style={{
							width: '100%',
							maxWidth: containerWidth,
							minWidth: '600px',
							height: containerHeight,
							maxHeight: containerHeight,
							overflowX: 'auto',
							overflowY: 'auto'
						}}>
						<div style={{minWidth: 'max-content'}}>
							<MUIDataTable
								title={language.item_distribution_analysis + " (Based on Total Outlet Visited)"}
								data={reportData3}
								columns={preferredColumns3}
								options={{
									search: false,
									print: false,
									filter: false,
									download: false,
									selectableRows: 'none',
									rowsPerPage: 100,
									rowsPerPageOptions: [100, 200, 300, 400],
									responsive: 'standard',
									pagination: true,
									tableBodyMaxHeight: `calc(${containerHeight} - 80px)`,
									onColumnViewChange: onPrefColumnViewChange3,
									setTableProps: () => ({size: 'small'}),
									customToolbar: () =>
										<Grid container alignItems="center" justifyContent="flex-end" spacing={2} style={{marginTop: -57, paddingRight: 60}}>
											<Grid item style={{marginTop: 4}}>
												<FormControlLabel
													control={
														<Switch
															checked={toggleState3}
															onClick={handleToggleChange3}
															color="primary"
														/>
													}
													label="Total Outlet Visited"
													labelPlacement="start"
												/>
											</Grid>

											<Grid item>
												<CheckinTableReportButton onGenerateReport={onGenerateReport} />
											</Grid>
										</Grid>
								}}
							/>
						</div>
					</div>
                )
            }
			
			{/* Alternative API Tables - shown when toggleState is true */}
			{
                selectedTab === 0 && toggleState1 == true && reportDataAlt.length > 0 && (
                    <div 
						className={classes.customScrollContainer}
						style={{
							width: '100%',
							maxWidth: containerWidth,
							minWidth: '600px',
							height: containerHeight,
							maxHeight: containerHeight,
							overflowX: 'auto',
							overflowY: 'auto'
						}}>
						<div style={{minWidth: 'max-content'}}>
							<MUIDataTable
								title={language.item_distribution_analysis + " (Based on Total Outlet Assigned)"}
								data={reportDataAlt}
								columns={preferredColumnsAlt1}
								options={{
									search: false,
									print: false,
									filter: false,
									download: false,
									selectableRows: 'none',
									rowsPerPage: 100,
									rowsPerPageOptions: [100, 200, 300, 400],
									responsive: 'standard',
									pagination: true,
									tableBodyMaxHeight: `calc(${containerHeight} - 80px)`,
									onColumnViewChange: onPrefColumnViewChangeAlt1,
									setTableProps: () => ({size: 'small'}),
									customToolbar: () =>
										<Grid container alignItems="center" justifyContent="flex-end" spacing={2} style={{marginTop: -57, paddingRight: 60}}>
											<Grid item style={{marginTop: 4}}>
												<FormControlLabel
													control={
														<Switch
															checked={toggleState1}
															onClick={handleToggleChange1}
															color="primary"
														/>
													}
													label="Total Outlet Assigned"
													labelPlacement="start"
												/>
											</Grid>

											<Grid item>
												<CheckinTableReportButton onGenerateReport={onGenerateReportAlt} />
											</Grid>
										</Grid>
								}}
							/>
						</div>
					</div>
                )
            }
			{
                selectedTab === 1 && toggleState2 == true && reportDataAlt2.length > 0 && (
                    <div 
						className={classes.customScrollContainer}
						style={{
							width: '100%',
							maxWidth: containerWidth,
							minWidth: '600px',
							height: containerHeight,
							maxHeight: containerHeight,
							overflowX: 'auto',
							overflowY: 'auto'
						}}>
						<div style={{minWidth: 'max-content'}}>
							<MUIDataTable
								title={language.item_distribution_analysis + " (Based on Total Outlet Assigned)"}
								data={reportDataAlt2}
								columns={preferredColumnsAlt2}
								options={{
									search: false,
									print: false,
									filter: false,
									download: false,
									selectableRows: 'none',
									rowsPerPage: 100,
									rowsPerPageOptions: [100, 200, 300, 400],
									responsive: 'standard',
									pagination: true,
									tableBodyMaxHeight: `calc(${containerHeight} - 80px)`,
									onColumnViewChange: onPrefColumnViewChangeAlt2,
									setTableProps: () => ({size: 'small'}),
									customToolbar: () =>
										<Grid container alignItems="center" justifyContent="flex-end" spacing={2} style={{marginTop: -57, paddingRight: 60}}>
											<Grid item style={{marginTop: 4}}>
												<FormControlLabel
													control={
														<Switch
															checked={toggleState2}
															onClick={handleToggleChange2}
															color="primary"
														/>
													}
													label="Total Outlet Assigned"
													labelPlacement="start"
												/>
											</Grid>

											<Grid item>
												<CheckinTableReportButton onGenerateReport={onGenerateReportAlt} />
											</Grid>
										</Grid>
								}}
							/>
						</div>
					</div>
                )
            }
			{
                selectedTab === 2 && toggleState3 == true && reportDataAlt3.length > 0 && (
                    <div 
						className={classes.customScrollContainer}
						style={{
							width: '100%',
							maxWidth: containerWidth,
							minWidth: '600px',
							height: containerHeight,
							maxHeight: containerHeight,
							overflowX: 'auto',
							overflowY: 'auto'
						}}>
						<div style={{minWidth: 'max-content'}}>
							<MUIDataTable
								title={language.item_distribution_analysis + " (Based on Total Outlet Assigned)"}
								data={reportDataAlt3}
								columns={preferredColumnsAlt3}
								options={{
									search: false,
									print: false,
									filter: false,
									download: false,
									selectableRows: 'none',
									rowsPerPage: 100,
									rowsPerPageOptions: [100, 200, 300, 400],
									responsive: 'standard',
									pagination: true,
									tableBodyMaxHeight: `calc(${containerHeight} - 80px)`,
									onColumnViewChange: onPrefColumnViewChangeAlt3,
									setTableProps: () => ({size: 'small'}),
									customToolbar: () =>
										<Grid container alignItems="center" justifyContent="flex-end" spacing={2} style={{marginTop: -57, paddingRight: 60}}>
											<Grid item style={{marginTop: 4}}>
												<FormControlLabel
													control={
														<Switch
															checked={toggleState3}
															onClick={handleToggleChange3}
															color="primary"
														/>
													}
													label="Total Outlet Assigned"
													labelPlacement="start"
												/>
											</Grid>

											<Grid item>
												<CheckinTableReportButton onGenerateReport={onGenerateReportAlt} />
											</Grid>
										</Grid>
								}}
							/>
						</div>
					</div>
                )
            }

            <VirtualListCB
				open={spView}
				setClose={data => OutletVisitSPViewClose(data)}
				title={language.salesperson}
				data={splist}
				language={language}
			/>

			<VirtualListCB
				open={outletView}
				setClose={data => OutletVisitOutletViewClose(data)}
				title={"Outlet"}
				data={outletList}
				language={language}
                filteration={1}
			/>

            <VirtualListCB
				open={categoryListView}
				setClose={data => CategoryViewClose(data)}
				title={"Outlet Category"}
				data={outletCategoryList}
				language={language}
                filteration={1}
			/>

            <VirtualListCB
				open={stateListView}
				setClose={data => StateViewClose(data)}
				title={"State"}
				data={stateList}
				language={language}
				filteration={0}
			/>

            <VirtualListCB
				open={productListView}
				setClose={data => ProductViewClose(data)}
				title={"Product"}
				data={itemList}
				language={language}
				filteration={1}
			/>

			<DateRangePickerModal
				setPositive={range => {
					setOutletVisitDateRange(range);
					setOpenOutletVisitDateDoc(false)
				}}
				setNegative={() => {
					setOpenOutletVisitDateDoc(false)
				}}
				setClose={() => {
					setOpenOutletVisitDateDoc(false)
				}}
                // limit={12}
				open={openOutletVisitDateDoc}
				message={language.date_range}
				positive={language.ok}
				negative={language.cancel}
			/>
		</div>
	)
}

function CheckinTableReportButton({onGenerateReport}) {
	return (
		<React.Fragment>
			<Tooltip title={'Generate Report'}>
				<IconButton
					edge={'end'}
					color={'primary'}
					onClick={() => onGenerateReport()} aria-label="addnew">
					<AssessmentIcon/>
				</IconButton>
			</Tooltip>
		</React.Fragment>
	)
}